import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import RepairIraiSyunkoReportList from '../../../../../components/templates/RepairIrai/KoziDone/RepairIraiSyunkoReport/List';
import {authOperations} from '../../../../../reducks/auth';
import {commonOperations} from '../../../../../reducks/common';

const mapStateToProps = (state) => ({
  currentTheme: state.style.theme,
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  getUserInfo: authOperations.getUserInfoOperation,
};

/**
 * 竣工届申込対象一覧(改修依頼) ページ。
 * 画面ID:1486
 */
class App extends React.Component {
  async componentDidMount() {
    window.scrollTo(0, 0);
    const ret = await this.props.getUserInfo();
    this.doJudge(ret);
  }

  /**
   * ログイン判定
   * @param {*} ret
   */
  doJudge = (ret) => {
    if (ret !== 'OK' || !this.props.userInfo) {
      const {doShowMessage} = this.props;
      const dialog = {
        message: 'CS0001',
        action: this.doMoveLogin,
      };
      doShowMessage(dialog);
    }
  }

  /**
   * ログイン画面へ遷移
   */
  doMoveLogin = () => {
    this.props.history.push('/login');
  }

  render() {
    return (<RepairIraiSyunkoReportList
      {...this.props}
    />);
  }
}

const ContainerApp = connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);

App.propTypes = {
  doShowMessage: PropTypes.func,
  getUserInfo: PropTypes.func,
  userInfo: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default ContainerApp;
